export const SECTORS = [
  // Most-searched commercial hubs first
  "Blue Area", "F-6", "F-7", "F-8", "F-10", "F-11", "G-9", "G-10", "G-11", "E-11",
  // Other F & G sectors
  "F-5", "F-12", "G-5", "G-6", "G-7", "G-8", "G-13", "G-14", "G-15", "G-16",
  // H, I & E sectors
  "H-8", "H-9", "H-11", "H-12", "H-13",
  "I-8", "I-9", "I-10", "I-11", "I-12", "I-14", "I-15", "I-16",
  "E-7", "E-12", "D-12",
  "Aabpara", "Melody",
  // DHA phases
  "DHA Phase 1", "DHA Phase 2", "DHA Phase 3", "DHA Phase 4", "DHA Phase 5", "DHA Phase 6", "DHA Valley",
  // Bahria Town
  "Bahria Town Phase 1", "Bahria Town Phase 2", "Bahria Town Phase 3", "Bahria Town Phase 4",
  "Bahria Town Phase 5", "Bahria Town Phase 6", "Bahria Town Phase 7", "Bahria Town Phase 8",
  "Bahria Enclave",
  // Popular housing societies & towns
  "Gulberg Greens", "Gulberg Residencia", "PWD Housing", "Media Town", "Soan Garden",
  "Faisal Town", "Ghauri Town", "Pakistan Town", "Naval Anchorage", "Korang Town",
  "Margalla Town", "Model Village", "CBR Town", "Chak Shahzad", "Bani Gala",
  // Suburbs & rural union councils
  "Bhara Kahu", "Nurpur Shahan", "Tarnol", "Golra Sharif", "Nilore", "Sihala", "Rawat", "Simly Dam",
];

export const CATEGORIES = [
  {
    key: "home_services",
    name: "Home Services",
    icon: "wrench",
    color: "#0A5C36",
    tag: "Trusted local pros",
    sub: [
      { key: "electrician", name: "Electrician" },
      { key: "plumber", name: "Plumber" },
      { key: "ac_repair", name: "AC Repair" },
      { key: "cleaning", name: "Cleaning" },
      { key: "carpenter", name: "Carpenter" },
    ],
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    key: "food_restaurants",
    name: "Food & Restaurants",
    icon: "utensils",
    color: "#059669",
    tag: "Islamabad's best bites",
    sub: [
      { key: "cafes", name: "Cafes" },
      { key: "restaurants", name: "Restaurants" },
      { key: "home_chefs", name: "Home Chefs" },
      { key: "bakers", name: "Bakers" },
    ],
    image: "https://images.unsplash.com/photo-1551632436-cbf8dd35adfa?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    key: "salons_beauty",
    name: "Salons & Beauty",
    icon: "sparkles",
    color: "#0A5C36",
    tag: "Book beauty near you",
    sub: [
      { key: "salons", name: "Salons" },
      { key: "home_beauticians", name: "Home Beauticians" },
      { key: "spa", name: "Spa" },
    ],
    image: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

export function categoryImage(key) {
  return CATEGORY_MAP[key]?.image;
}
